import { NgModule } from '@angular/core';
import { provideState } from '@ngrx/store';
import { notificationsFeatureKey, notificationReducer } from './+state/notifications/notification.reducer';
import { provideEffects } from '@ngrx/effects';
import { NotificationEffects } from './+state/notifications/notification.effects';

@NgModule({
    providers: [provideState(notificationsFeatureKey, notificationReducer), provideEffects([NotificationEffects])]
})
export class NotificationModule {}
